import React, { useState, useEffect } from 'react';
import { Check, X, Eye, FileText } from 'lucide-react';
import { getAuthorizedHeaders } from '../utils/authorizedHeaders';

//const API_BASE = 'http://localhost:3001';
const API_BASE = 'https://warngen-api-352514293915.europe-west1.run.app';

const ApprovalQueue = ({ usuario, darkMode }) => {
    const [pendientes, setPendientes] = useState([]);
    const [cargando, setCargando] = useState(true);

    const fetchPendientes = async () => {
        try {
            setCargando(true);
            const token = localStorage.getItem('token');
            const res = await fetch(`${API_BASE}/api/enviar/pendientes`, {
                //headers: token ? { 'Authorization': `Bearer ${token}` } : {}
                headers: getAuthorizedHeaders()
            });
            if (res.ok) {
                const data = await res.json();
                setPendientes(data);
            }
        } catch (error) {
            console.error('Error fetching pendientes:', error);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        fetchPendientes();
    }, []);

    const procesarAlerta = async (id, accion) => {
        if (!window.confirm(`¿Seguro que deseas ${accion === 'aprobar' ? 'aprobar y enviar' : 'rechazar'} esta alerta?`)) return;

        try {
            const res = await fetch(`${API_BASE}/api/enviar/${id}/${accion}`, {
                method: 'PATCH',
                headers: getAuthorizedHeaders(),
                body: JSON.stringify({ aprobador_id: usuario?.id })
            });
            
            const data = await res.json();
            if (res.ok && data.success) {
                if (data.scheduled) {
                    alert(data.mensaje || 'Alerta aprobada y dejada en cola programada para su fecha de envío.');
                } else {
                    alert(`Alerta ${accion === 'aprobar' ? 'aprobada y enviada' : 'rechazada'} exitosamente.` + (accion === 'aprobar' ? `\nEnviados exitosos: ${data.exitosos}\nFallidos: ${data.fallidos}` : ''));
                }
                fetchPendientes();
            } else {
                alert('Error al procesar alerta: ' + (data.error || 'Error desconocido'));
            }
        } catch (error) {
            console.error('Error procesando alerta:', error);
            alert('Error de conexión');
        }
    };

    if (usuario?.rol === 'operador') {
        return <div className="p-8 text-center text-red-500">No tienes permisos para acceder a esta sección.</div>;
    }

    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Cola de Aprobación de Alertas</h2>

            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">Alertas Pendientes ({pendientes.length})</h3>
                    <button onClick={fetchPendientes} className="text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 py-1 px-3 rounded dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-300">
                        Refrescar
                    </button>
                </div>

                {cargando ? (
                    <p className="text-center text-gray-500 py-8">Cargando alertas...</p>
                ) : pendientes.length === 0 ? (
                    <div className="text-center py-12 bg-gray-50 dark:bg-gray-700/50 rounded-lg border-2 border-dashed border-gray-200 dark:border-gray-600">
                        <FileText size={48} className="mx-auto text-gray-300 dark:text-gray-500 mb-3" />
                        <p className="text-gray-500 dark:text-gray-400 font-medium">No hay alertas pendientes de aprobación</p>
                        <p className="text-sm text-gray-400 dark:text-gray-500 mt-1">Cuando los operadores creen alertas, aparecerán aquí.</p>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {pendientes.map(alerta => {
                            let variables = {};
                            try { variables = JSON.parse(alerta.variables_sustituidas || '{}').variables || {}; } catch(e){}
                            
                            return (
                                <div key={alerta.id} className="border border-yellow-200 dark:border-yellow-900 bg-yellow-50/50 dark:bg-yellow-900/10 rounded-lg p-4 shadow-sm hover:shadow-md transition">
                                    <div className="flex flex-col sm:flex-row justify-between items-start gap-2 mb-3">
                                        <div>
                                            <div className="flex flex-wrap items-center gap-2 mb-1">
                                                <span className="font-bold text-gray-800 dark:text-gray-100">{alerta.plantilla_nombre}</span>
                                                <span className="text-xs px-2 py-0.5 bg-gray-200 dark:bg-gray-700 rounded text-gray-700 dark:text-gray-300 uppercase">{alerta.canal}</span>
                                            </div>
                                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                                Creada por <span className="font-semibold text-gray-700 dark:text-gray-300">{alerta.creador_nombre || 'Desconocido'}</span> el {new Date(alerta.fecha_creacion).toLocaleString()}
                                            </p>
                                            {(alerta.fecha_programada_ms || alerta.fecha_programada) && (
                                                <p className="text-xs font-semibold text-blue-700 dark:text-blue-300 mt-1">
                                                    Envío programado para: {new Date(alerta.fecha_programada_ms ? Number(alerta.fecha_programada_ms) : alerta.fecha_programada).toLocaleString('es-ES')}
                                                </p>
                                            )}
                                        </div>
                                        <div className="sm:text-right flex sm:block items-center gap-2">
                                            <span className="text-xs sm:text-sm font-semibold text-yellow-600 dark:text-yellow-500 bg-yellow-100 dark:bg-yellow-900/50 px-2 py-1 rounded">Pendiente</span>
                                            <p className="text-xs text-gray-500 dark:text-gray-400 sm:mt-1">{alerta.total_destinatarios} destinatarios</p>
                                        </div>
                                    </div>
                                    
                                    <div className="bg-white dark:bg-gray-800 rounded border dark:border-gray-700 p-3 mb-4 text-sm mt-3">
                                        <div className="font-mono text-xs text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-900 p-2 rounded max-h-32 overflow-y-auto">
                                            <strong>Variables:</strong><br/>
                                            {Object.keys(variables).length > 0 ? 
                                                Object.entries(variables).map(([k,v]) => <div key={k}>{k}: {v}</div>) 
                                            : <span className="italic">Sin variables</span>}
                                        </div>
                                    </div>

                                    <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 pt-3 border-t border-yellow-200 dark:border-yellow-900/50">
                                        <button 
                                            onClick={() => procesarAlerta(alerta.id, 'rechazar')}
                                            className="px-4 py-2 flex items-center justify-center gap-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30 rounded border border-red-200 dark:border-red-900 transition"
                                        >
                                            <X size={16} /> Rechazar
                                        </button>
                                        <button 
                                            onClick={() => procesarAlerta(alerta.id, 'aprobar')}
                                            className="px-4 py-2 flex items-center justify-center gap-2 bg-green-600 text-white hover:bg-green-700 rounded transition font-medium"
                                        >
                                            <Check size={16} /> Aprobar y Enviar
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ApprovalQueue;
